const HUBSPOT_QUERY_KEYS = ['__hstc', '__hssc', '__hsfp'] as const;
const HUBSPOT_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 180; // In line with normal HubSpot cookies' expiration

export const syncHubspotTrackingParamsFromUrl = (): void => {
    const url = new URL(window.location.href);
    let hasHubspotParams = false;

    HUBSPOT_QUERY_KEYS.forEach((key) => {
        const value = url.searchParams.get(key);
        if (value === null) {
            return;
        }

        document.cookie = `${key}=${encodeURIComponent(value)}; path=/; max-age=${HUBSPOT_COOKIE_MAX_AGE_SECONDS}; samesite=lax`;
        url.searchParams.delete(key);
        hasHubspotParams = true;
    });

    if (!hasHubspotParams) {
        return;
    }

    const sanitizedSearch = url.searchParams.toString();
    const sanitizedUrl = `${url.pathname}${sanitizedSearch ? `?${sanitizedSearch}` : ''}${url.hash}`;
    window.history.replaceState(window.history.state, '', sanitizedUrl);
};

